import { makeStyles } from '@material-ui/core';
import { distances } from '@setvi/shared/styles';

export const useNavbarStyles = makeStyles(
  ({ transitions, spacing, palette }) => ({
    container: {
      display: 'flex',
      width: '100%',
      borderBottom: `1px solid ${palette.divider}`
    },
    imgContainer: {
      padding: distances.base
    },
    wrapper: {
      padding: spacing(3, 4),
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: 'none',
      transition: transitions.create(['width', 'margin'], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.leavingScreen
      })
    }
  })
);
